const initializeDialogs = (openDialogButtons, closeDialogButtons, allDialogs) => {
  allDialogs.forEach( (dialog) => {
    dialog.addEventListener( 'click', function (event) {
      const rect = dialog.getBoundingClientRect();
      const isInDialog = (
        rect.top <= event.clientY
        && event.clientY <= rect.top + rect.height
        && rect.left <= event.clientX
        && event.clientX <= rect.left + rect.width
      );
      if (!isInDialog) {
        dialog.close();
      }
    } );
  } );

  openDialogButtons.forEach( (dialogButton) => {
    const dialogToShow = dialogButton.dataset.openDialog;

    if (!dialogToShow) {
      return;
    }

    const dialog = document.querySelector( '[data-dialog=' + dialogToShow + ']' );

    dialogButton.addEventListener( 'click', event => {
      dialog.showModal();
      const iframe = dialog.querySelector('.video__embed iframe');
      if (iframe) {
        // Forceer autoplay door src te herladen met autoplay=1
        const src = iframe.getAttribute('src');

        // Vermijd dubbele autoplay param
        const cleanSrc = src.replace(/(&|\?)autoplay=1/, '');

        // Herlaad de iframe met autoplay=1
        iframe.setAttribute('src', cleanSrc + (cleanSrc.includes('?') ? '&' : '?') + 'autoplay=1');
      }
      dialog.focus();
    } );
  } );

  closeDialogButtons.forEach( (dialogButton) => {
    const dialogToClose = dialogButton.dataset.closeDialog;

    if (!dialogToClose) {
      return;
    }

    const dialog = document.querySelector( '[data-dialog=' + dialogToClose + ']' );

    dialog.addEventListener('close', () => {
      const video = dialog.querySelector('.video__embed iframe');
      if (video) {
        const player = new Vimeo.Player(video);
        player.pause().then(() => {
          player.setCurrentTime(0);
        });
      }
      dialog.close();
    });

    dialogButton.addEventListener( 'click', event => {
      dialog.close();
    } );
  } );
};

const dialogs = (openDialogButtons, closeDialogButtons, allDialogs) => {
  if (!openDialogButtons || !closeDialogButtons) {
    return;
  }

  initializeDialogs( openDialogButtons, closeDialogButtons, allDialogs );
};

export default dialogs;